import { motion } from "motion/react";
import { ChevronRight } from "lucide-react";

/**
 * Kaskad izi — kod bosqichma-bosqich qanday yig'ilgani.
 *
 * `4 xona -> 6 xona -> 10 xona`. Bu bezak emas: foydalanuvchi kodning
 * QAYERDAN kelganini ko'radi va noto'g'ri bosqichni o'zi payqaydi.
 */
export function CascadeTrail({ levels, ms }) {
  if (!levels?.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {levels.map((l, i) => (
        <motion.div
          key={`${l.level}-${l.code}`}
          initial={{ opacity: 0, scale: 0.94 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: i * 0.08, duration: 0.25 }}
          className="flex items-center gap-1.5"
        >
          {i > 0 && (
            /*
              Keyingi kod oldingisidan boshlanmasa — kaskad BOSHQA
              shoxni tanlagan (beam search). Oddiy strelka bunda
              yolg'on gapiradi: "8807 -> 830241" uzilgan zanjirdek
              ko'rinadi. Shuning uchun belgi boshqacha.
            */
            l.code?.startsWith(levels[i - 1].code) ? (
              <ChevronRight className="h-3 w-3 shrink-0 text-sky-600/60" />
            ) : (
              <span
                title="Kaskad boshqa guruhni kuchliroq topdi"
                className="shrink-0 px-0.5 font-mono text-[11px] text-amber-400/70"
              >
                ⇢
              </span>
            )
          )}

          <div
            className="flex items-center gap-1.5 rounded-lg border border-sky-700/40 bg-[#051733]/80 px-2 py-1"
            title={l.title || ""}
          >
            <span className="rounded bg-sky-950/80 px-1 py-0.5 font-mono text-[10px] font-semibold text-sky-400">
              {l.level}x
            </span>
            <span className="font-mono text-xs font-bold tracking-wide text-white">
              {l.code}
            </span>
            {l.count > 1 && (
              <span className="text-[10px] text-sky-300/50">{l.count} nomzod</span>
            )}
          </div>
        </motion.div>
      ))}

      {ms > 0 && (
        <span className="ml-auto font-mono text-[10px] text-sky-400/50">
          {(ms / 1000).toFixed(1)}s
        </span>
      )}
    </div>
  );
}
